import React from "react";

import selectedDateIcon from "./../../i/icons/selected-date.svg";
import errorIcon from "./../../i/icons/error.svg";

export const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = "Required";
  } else if (!/\S+@\S+\.\S+/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
  if (!values.password) {
    errors.password = "Required";
  } else if (!regex.test(values.password)) {
    errors.password =
      "Passwords must be at least 8 characters and must contain a combination of letters, numerals, capital letters, and a special character such as #!()*&%$";
  }

  if (!values.password2) {
    errors.password2 = "Required";
  } else if (!regex.test(values.password2)) {
    errors.password2 =
      "Passwords must be at least 8 characters and must contain a combination of letters, numerals, capital letters, and a special character such as #!()*&%$";
  }
  if (values.password !== values.password2) {
    errors.password2 = "Passwords do not match";
  }

  return errors;
};

export const renderField = ({
  input,
  className,
  placeholder,
  type,
  meta: { touched, error, warning }
}) => (
  <div style={{ position: "relative" }}>
    <input
      {...input}
      className={className}
      placeholder={placeholder}
      type={type}
    />
    {touched && !error && (
      <img
        className="date-range-presets-autosuggest-item--selected-icon"
        style={{ position: "absolute", top: "40%", right: 0 }}
        src={selectedDateIcon}
        alt="Validation Success"
      />
    )}
    {touched && error && (
      <img
        className="date-range-presets-autosuggest-item--selected-icon"
        style={{ position: "absolute", top: "40%", right: 0 }}
        src={errorIcon}
        alt="Validation Error"
      />
    )}
  </div>
);
